import React, { useRef, useState } from "react";
import { FiLoader, FiUploadCloud } from "react-icons/fi";
import { card } from "../VideoStudioPanel";

// The place to choose or drop a video. The hidden file input is here too, so a tool needs only `onFile`.
export default function VideoDropZone({ reading, onFile, hint = "MP4, MOV or WebM, up to 2 GB. It stays on your computer." }) {
  const input = useRef(null);
  const [dragging, setDragging] = useState(false);
  return (
    <>
      <div onClick={() => input.current?.click()} onDragOver={(e) => { e.preventDefault(); setDragging(true); }} onDragLeave={() => setDragging(false)}
        onDrop={(e) => { e.preventDefault(); setDragging(false); onFile(e.dataTransfer.files[0]); }} role="button" tabIndex={0} onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && input.current?.click()}
        className={`${card} cursor-pointer border-2 border-dashed text-center py-16 transition-colors ${dragging ? "border-accent-light bg-accent/10" : "border-navy-border hover:border-accent-light/70"}`}>
        {reading ? <FiLoader className="mx-auto animate-spin text-accent-light" size={34} /> : <FiUploadCloud className="mx-auto text-accent-light" size={38} />}
        <p className="mt-3 text-gray-100 font-medium">{reading ? "Opening the video..." : "Click to choose a video, or drop it here"}</p>
        <p className="text-xs text-gray-500 mt-1.5">{hint}</p>
      </div>
      <input ref={input} type="file" accept="video/*,.mp4,.mov,.m4v,.webm,.mkv" className="hidden" onChange={(e) => { onFile(e.target.files?.[0]); e.target.value = ""; }} />
    </>
  );
}
